/**
 * @file conversationService.js
 * @description APIs for Conversation related requests.
 **/

import { contentHttp, conversationApiHttp } from "./httpService";

/**
 * Retrieve the tenant ID from local storage.
 * @returns {string|null} The tenant ID or null if not found.
 */
const getTenantId = () => +window.localStorage.getItem("tenantId");

export const createConversation = async (payload) => {
  let tenantID = getTenantId();
  try {
    const response = await conversationApiHttp.post(`/v2/conversation/${tenantID}/conversation`, payload);
    return response?.data || null;
  } catch (error) {
    console.error("Error creating conversation:", error);
    throw error;
  }
}

export const getAllConversations = async (topicType = null, topicId = null, authorId = null, messages = false) => {
  let tenantID = getTenantId();
  let params = `messages=${messages}`;
  if (topicType)
    params += `&topicType=${topicType}`;
  if (topicId)
    params += `&topicId=${topicId}`;
  if (authorId)
    params += `&authorId=${authorId}`;
  try {
    const response = await conversationApiHttp.get(`/v2/conversation/${tenantID}/conversation?${params}`);
    return response?.data || null;
  } catch (error) {
    console.error("Error getting all conversations:", error);
    throw error;
  }
}

export const getAllMessages = async (conversationId, authorId, descendants = false) => {
  let tenantID = getTenantId();
  let params = `descendants=${descendants}`;
  params += `&conversationId=${conversationId}`;
  params += `&authorId=${authorId}`;
  try {
    const response = await conversationApiHttp.get(`/v2/conversation/${tenantID}/message?${params}`);
    return response?.data || null;
  } catch (error) {
    console.error("Error getting all messages:", error);
    throw error;
  }
}

export const createMessage = async (payload) => {
  let tenantID = getTenantId();
  try {
    const response = await conversationApiHttp.post(`/v2/conversation/${tenantID}/message`, payload);
    return response?.data || null;
  } catch (error) {
    console.error("Error creating message:", error);
    throw error;
  }
}

export const createMessageWithAsset = async (payload) => {
  let tenantID = getTenantId();
  try {
    const response = await contentHttp.post(`/v2/content/tenant/${tenantID}/containers/asset`, payload);
    return response?.data || null;
  } catch (error) {
    console.error("Error creating message with asset:", error);
    throw error;
  }
}

export const deleteAssetWithMessage = async (assetUploadPartId, assetId, conversationId) => {
  let tenantID = getTenantId();
  try {
    const response = await contentHttp.delete(
      `/v2/content/tenant/${tenantID}/containers/asset/${assetUploadPartId}?assetId=${assetId}&conversationId=${conversationId}`
    );
    return response?.data || null;
  } catch (error) {
    console.error("Error deleting asset with message:", error);
    throw error;
  }
}